import React from 'react';
import { Link } from 'react-scroll';
import { FaWhatsapp, FaGithub, FaEnvelope, FaFacebook, FaInstagram } from 'react-icons/fa';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-white relative">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center pt-[50px]">
          {/* Left Content */}
          <div className="text-left animate-fadeInUp p-5">
            <p className="text-2xl md:text-3xl text-gray-600 mb-4 font-light">
              Hi, I am
            </p>
            <h1 className="hero-title mb-6">
              <span className="gradient-text">Dhananjay Pandey</span>
            </h1>
            <p className="hero-subtitle">
              Professional Astrologer & Spiritual Guide
            </p>
            <p className="hero-description mb-8">
              As a professional astrologer, my mission is to help you understand the deeper patterns of your life through the lens of astrology. Whether you’re seeking clarity in relationships, purpose in your career or guidance through a period of transition, your birth chart holds powerful insight waiting to be unlocked.Let’s explore your stars together and illuminate the path ahead.
            </p>

            {/* Social Links */}
            <div className="flex space-x-4 mb-8">
              <a
                href="https://api.whatsapp.com/send/?phone=919838697226&text&type=phone_number&app_absent=0"
                className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-all duration-300 hover:scale-110"
                aria-label="WhatsApp"
              >
                <FaWhatsapp size={20} />
              </a>
              <a
                href="https://www.instagram.com/dhananjay.pandey.1441?igsh=N2RseWxrbzQzZzds"
                className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full flex items-center justify-center hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/bhatnipandit?mibextid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="mailto:dkpandeybhatni@gmail.com"
                className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-all duration-300 hover:scale-110"
                aria-label="Email"
              >
                <FaEnvelope size={20} />
              </a>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="contact"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn-primary cursor-pointer text-center"
              >
                Book Consultation
              </Link>
              <Link
                to="about"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn-secondary cursor-pointer text-center"
              >
                Learn More
              </Link>
            </div>
          </div>

          {/* Right Content - Profile Image */}
          <div className="flex justify-center lg:justify-end animate-slideInRight">
            <div className="relative">
              {/* Background decoration */}
              <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-secondary/20 rounded-full blur-2xl"></div>

              {/* Main image container  */}
                      <div className="relative w-80 h-128 md:w-96 md:h-128 rounded-[20px] overflow-hidden shadow-2xl border-8 border-white" style={{ height: '512px' }}>
                      <img
                        src="/images/user/IMG-20250831-WA0014 - s.jpg"
                        alt="Dhananjay Pandey Bhatni - Professional Astrologer"
                        className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
                        onError={(e) => {
                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='384' height='384' viewBox='0 0 384 384'%3E%3Cdefs%3E%3ClinearGradient id='gradient' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%232563eb;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23f59e0b;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='384' height='384' fill='%23f8fafc'/%3E%3Ctext x='192' y='160' font-family='Poppins, sans-serif' font-size='48' font-weight='bold' text-anchor='middle' fill='url(%23gradient)'%3EDK%3C/text%3E%3Ctext x='192' y='200' font-family='Poppins, sans-serif' font-size='24' text-anchor='middle' fill='%236b7280'%3EPANDEY%3C/text%3E%3Ctext x='192' y='230' font-family='Poppins, sans-serif' font-size='24' text-anchor='middle' fill='%236b7280'%3EBHATNI%3C/text%3E%3C/svg%3E";
                  }}
                />
              </div>

              {/* Floating elements */}
              <div className="absolute top-4 -right-4 w-8 h-8 bg-primary rounded-full animate-float opacity-80"></div>
              <div className="absolute bottom-8 -left-4 w-6 h-6 bg-secondary rounded-full animate-float opacity-60" style={{ animationDelay: '2s' }}></div>
              <div className="absolute top-1/2 -right-8 w-4 h-4 bg-accent rounded-full animate-float opacity-70" style={{ animationDelay: '4s' }}></div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 animate-fadeInUp">
          <div className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300">
            <div className="text-4xl font-bold text-primary mb-2">1000+</div>
            <div className="text-gray-600 font-medium">Happy Clients</div>
          </div>
          <div className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300">
            <div className="text-4xl font-bold text-primary mb-2">22+</div>
            <div className="text-gray-600 font-medium">Years Experience</div>
          </div>
          <div className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300">
            <div className="text-4xl font-bold text-primary mb-2">1000+</div>
            <div className="text-gray-600 font-medium">Accurate Readings</div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute animate-bounce -bottom-9" style={{ bottom: '-36px', left: 'calc(50% - 15px)' }}>
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
